import React, { useState } from "react";
import "../../style/pages/categoriespage/gloves.css";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header.jsx";
import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import g1 from "../../media3/categories/g1.png";
import g2 from "../../media3/categories/g2.png";
import g3 from "../../media3/categories/g3.png";
import g4 from "../../media3/categories/g4.png";
import g5 from "../../media3/categories/g5.png";
import g6 from "../../media3/categories/g6.png";
import g7 from "../../media3/categories/g7.png";
import g8 from "../../media3/categories/g8.png";
import g9 from "../../media3/categories/g9.png";
import g10 from "../../media3/categories/g10.png";
import g11 from "../../media3/categories/g11.png";
import g12 from "../../media3/categories/g12.png";
import g13 from "../../media3/categories/g13.png";
import g14 from "../../media3/categories/g14.png";
import g15 from "../../media3/categories/g15.png";
import g16 from "../../media3/categories/g16.png";
import g17 from "../../media3/categories/g17.png";
import g18 from "../../media3/categories/g18.png";
import g19 from "../../media3/categories/g19.png";
import g20 from "../../media3/categories/g20.png";
import g21 from "../../media3/categories/g21.png";
import g22 from "../../media3/categories/g22.png";
import g23 from "../../media3/categories/g23.png";
import g24 from "../../media3/categories/g24.png";
import g from "../../media3/categories/g.png";

// Dummy data
export const glovesData = [
  { id: 1, name: "Sport Gloves | Slalom", img: g1, price: 61, maxPrice: 122, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Sport Gloves with red and white Slalom ski-themed patterns, gripping the slopes and weapons with alpine precision and style." },
  { id: 2, name: "Driver Gloves | Blaze", img: g2, price: 80, maxPrice: 150, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Driver Gloves engulfed in fiery orange Blaze flames, steering through combat with burning grip and elite control." },
  { id: 3, name: "Hand Wraps | Fade", img: g3, price: 95, maxPrice: 160, color: "green", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Hand Wraps with a smooth green-to-blue Fade gradient, wrapping fists in chromatic toughness and fluid motion." },
  { id: 4, name: "Moto Gloves | Orion", img: g4, price: 120, maxPrice: 180, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Moto Gloves featuring cosmic blue Orion constellation patterns, accelerating handling with stellar night-time grip." },
  { id: 5, name: "Specialist Gloves | See7", img: g5, price: 70, maxPrice: 125, color: "green", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Specialist Gloves in green 'See Ya Later' mechanical alligator design, snapping into action with tactical bite." },
  { id: 6, name: "Bloodhound Gloves | Hyper", img: g6, price: 90, maxPrice: 140, color: "red", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Bloodhound Gloves with monstrous red Hyper Beast artwork, tracking prey with feral strength and instinct." },
  { id: 7, name: "Hydra Gloves | Fuel87", img: g7, price: 110, maxPrice: 160, color: "black", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Hydra Gloves with industrial black Fuel Injector mechanics, fueling multi-headed operation dominance with raw power." },
  { id: 8, name: "Sport Gloves | Melondrama", img: g8, price: 60, maxPrice: 120, color: "green", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Sport Gloves in juicy green Melondrama watermelon slices, punching with refreshing, fruity aggression." },
  { id: 9, name: "Driver Gloves | Llama", img: g9, price: 75, maxPrice: 130, color: "blue", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Driver Gloves with explosive blue Llama Cannon artwork, shifting gears with quirky, powerful handling." },
  { id: 10, name: "Moto Gloves | Kill", img: g10, price: 145, maxPrice: 200, color: "red", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Moto Gloves marked by red Kill Confirmed blood and bullet holes—proof of high-speed, confirmed eliminations." },
  { id: 11, name: "Hand Wraps | Bullet Queen", img: g11, price: 88, maxPrice: 150, color: "black", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Hand Wraps crowned with regal black Bullet Queen gold, ruling close-quarters combat with royal authority." },
  { id: 12, name: "Specialist Gloves | Han9", img: g12, price: 55, maxPrice: 110, color: "orange", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Specialist Gloves in orange Handgun-inspired grip texture, enhancing sidearm mastery with tactical precision." },
  { id: 13, name: "Bloodhound Gloves | Av7", img: g13, price: 68, maxPrice: 125, color: "orange", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Bloodhound Gloves with orange Avalanche insulated snow patterns, tracking through blizzards with frozen resilience." },
  { id: 14, name: "Hydra Gloves | Xiangliu", img: g14, price: 92, maxPrice: 160, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Hydra Gloves coiled in orange Xiangliu mythical serpent scales, gripping with multi-headed ancient venom." },
  { id: 15, name: "Sport Gloves | Muertos", img: g15, price: 63, maxPrice: 120, color: "purple", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Sport Gloves celebrating purple Muertos with Day of the Dead skulls, punching with festive cultural spirit." },
  { id: 16, name: "Driver Gloves | Angry Mob", img: g16, price: 85, maxPrice: 140, color: "white", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Driver Gloves wrapped in white Angry Mob protest graffiti, steering through riots with rebellious control." },
  { id: 17, name: "Moto Gloves | Cobra Strike", img: g17, price: 78, maxPrice: 130, color: "red", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Moto Gloves with red Cobra Strike racing snakes, accelerating grip in high-speed, venomous chases." },
  { id: 18, name: "Hand Wraps | Crazy 8", img: g18, price: 59, maxPrice: 110, color: "red", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Hand Wraps taped in red Crazy 8 dice chaos, fighting with gambling luck and bare-knuckle unpredictability." },
  { id: 19, name: "Specialist Gloves | Ticket9", img: g19, price: 99, maxPrice: 160, color: "green", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Specialist Gloves with green Ticket to Hell demonic flames, executing infernal operations with elite handling." },
  { id: 20, name: "Bloodhound Gloves | W9", img: g20, price: 115, maxPrice: 175, color: "green", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Bloodhound Gloves flowing with green Water Elemental liquid effects, tracking submerged trails with mystical grip." },
  { id: 21, name: "Hydra Gloves | Asiimov", img: g21, price: 102, maxPrice: 155, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Hydra Gloves in orange Asiimov futuristic geometry, commanding multi-operation dominance with sci-fi style." },
  { id: 22, name: "Sport Gloves | Pole Pose", img: g22, price: 66, maxPrice: 125, color: "red", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Sport Gloves in red Pole Position racing leather, gripping the lead on the competitive track with speed." },
  { id: 23, name: "Driver Gloves | Isaac", img: g23, price: 74, maxPrice: 130, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Driver Gloves with yellow Isaac holographic circuits, driving precision maneuvers in a tech-enhanced future." },
  { id: 24, name: "Moto Gloves | Boost Proto", img: g24, price: 97, maxPrice: 160, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Moto Gloves upgraded with yellow Boost Protocol glowing circuitry, overclocking grip for ultimate performance." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Gloves({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredGloves = glovesData.filter((glove) => {
  //   const inPrice = glove.price >= priceRange[0] && glove.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(glove.color);
  //   const inRating = !selectedRating || glove.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });
    let filteredGloves = glovesData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredGloves = [...filteredGloves].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
           <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
          selectedRarity={selectedRarity}
          handleRarityChange={handleRarityChange}
          selectedOrderBy={selectedOrderBy}
          handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredGloves}
          categoryImage={g}
          categoryAlt="CZ75-Auto"
          categoryTitle="Hydra Gloves | Asiimov"
          categoryDescription="Add flair to every move with our stunning collection of CS2 Glove skins.
          Designed to complement your weapons, these gloves showcase vibrant patterns and premium finishes.
          Whether you’re clutching a round or inspecting your knife, style is always in your hands.
      "
          onItemClick={handleNavigate}
          isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Gloves;